module.exports = __webpack_public_path__ + "img/biaoqian_gongan.42170b45.png";